export default {
  ONBOARDING_DYNAMIC: 'onboardDynamicEnabled',
  // PROGRAM_ONLINE_ONLY: 'onlineProgramOnlyEnabled',
  PROGRAM_FOS_FILTER: 'programFosFilterEnabled',
  GENESYS_CHAT_ENABLED: 'genesysChatEnabled',
  GENESYS_CLOUD_CHAT_ENABLED: 'genesysCloudChatEnabled',
  GENESYS_COBROWSE_ENABLED: 'genesysChatCobrowseEnabled',
  GENESYS_TEXT_ENABLED: 'genesysTextEnabled',
  QUICKAPP_PERSON_IMPORT_ENABLED: 'quickAppPersonImportEnabled',
  BRIDGE_PROGRAM_ENABLED: 'bridgeProgramEnabled',
  QUICKAPP_FORCE_LOGOUT: 'quickAppForceLogout',
  INVITE_TO_APPLY_PROGR_EXCLUDE_ENABLED: 'inviteToApplyProgramExcludedEnabled',
  BLACKBOARD_COLLABORATION_ENABLED: 'blackBoardCollaborationEnabled',
  MAINTENANCE_PAGE_ENABLED: 'maintenancePageEnabled',
  ENABLE_SAGAS_CANARY_DEPLOYMENT: 'enableSagasCanaryDeployment',
  ESIGN_CALLBACK_ENABLED: 'esigncallbackEnabled',
  NAVIGATION_ENABLED: 'navigationEnabled',
  ALUMNI_ONLY_ENABLED: 'alumniOnlyEnabled',
  SAGA_REDIRECT_MODAL_ENABLED: 'sagaRedirectModalEnabled',
  TAPCAP_ENABLED: 'tapcapEnabled',
  REENROLL_ONLINE_ONLY_ENABLED: 'reenrollOnlineOnlyEnabled',
  COGNITO_VALIDATION_ENABLED: 'cognitoValidationEnabled',
  CONTACT_V2_ENABLED: 'contactV2Enabled',
  PROGRAM_CHANGE_ENABLED: 'programChangeEnabled',
  ENABLE_APP_EXPIRATION: 'enableAppExpiration',
  ENABLE_ALLOY_EVENT: 'enableAlloyEvent',
  ENABLE_NAVIGATION_SWITCH: 'navigationSwitchEnabled',
  DGSP_ENABLED: 'dgspEnabled',
  NO_SSN_GRANTS_ENABLED: 'noSsnGrantsEnabled',
  ENABLE_APP_STATUS_SYNC_SRM: 'enableAppStatusSyncSrm',
  ENABLE_NEW_NAVIGATION: 'enableNewNavigation',
  SHOW_EMPLOYER_BENEFIT_MSG: 'showEmployerBenefitMsg',
  ENABLE_DASHBOARD_SWITCH: 'dashboardSwitchEnabled',
  PROGRAMCHANGE_AFTER_REG: 'programChangeAfterReg',
  NAE_DASHBOARD_ENABLED: 'dashboardEnabled',
  NAE_DASHBOARD_FIRST: 'dashboardFirst',
  FORGEROCK_SSO_ENABLED: 'forgerockSsoEnabled',
  ENABLE_ACPREPOP_COOKIE: 'enableACPrepopCookie',
  MOBILE_ADA_AUTOCOMPLETE_ENABLED: 'mobileAdaAutocompleteEnabled',
  RECAPTCHA_ENABLED: 'reCaptchaEnabled',
  SHOW_EMPLOYER_BORROW_MSG: 'showEmployerBorrowMsg',
  ENABLE_SAVED_PROGRAM_INFO: 'enableSavedProgramInfo',
  ENABLE_DUP_SSN_CHECK: 'enableDupSsnCheck',
  ENABLE_CRIMINAL_CONVICTION_INFO: 'enableCriminalConvictionInfo',
  ENABLE_MODIFIED_TAPCAP_FLOW: 'enableTapCapFlow',
  ENABLE_MODIFIED_TAPCAP_FLOW_TR: 'enableTapCapFlowTR',
  VALIDATE_EMAIL_ENABLED: 'validateEmailEnabled',
  PHR_ENABLED: 'phrEnabled',
  TERMINAL_FAILURE_MESSAGE_ENABLED: 'terminalFailureMessageEnabled',
  ENABLE_OTP: 'enableOtp',
  ENABLE_COMMUNITY_BENEFITS: 'enableCommunityBenefitsFlag',
  OTP_BEFORE_VIDEO_ENABLED: 'otpBeforeVideoEnabled',
  PRE_SIGN_OTP_ENABLED: 'preSignOtpEnabled',
  PROGRAM_HELP_UPDATE_ENABLED: 'programHelpUpdateEnabled',
  AAMVA_ENABLED: 'aamvaEnabled',
  ENABLE_CTA_DISABLED_UNTIL_VALID: 'enableCtaDisabledUntilValid',
  ENABLE_ALT_EMPLOYER_ON_WORKHISTORY: 'enableAltEmployerOnWorkHistory',
  LEX_BOT_ENABLED: 'lexBotEnabled',
  SUPER_PHOEBE_ENABLED: 'superPhoebeEnabled',
  PROGRAM_PAGE_REDESIGN_ENABLED: 'programPageRedesignEnabled',
  PROGRAM_PAGE_REDESIGN_TREATMENT_ENABLED: 'programPageRedesignTreatmentEnabled',
  ENABLE_EMPLOYER_PERSON_ASSOCIATION: 'enableEmployerPersonAssociation',
  ENABLE_EMPLOYER_FAMILY_BENEFIT: 'enableEmployerFamilyBenefit',
  SCHEDULE_A_CALL_ENABLED: 'scheduleACallEnabled',
  PRICING_ONLY_EMPLOYER_MATCH: 'pricingOnlyEmployerMatch',
  STACKABLE_SAVINGS_REDESIGN_ENABLED: 'stackableSavingsRedesignEnabled',
  PRICING_CHANGE_ENABLED: 'pricingChangeEnabled',
  MET_WORK_REQ_ENABLED: 'metWorkReqEnabled',
  MET_WORK_REQ_TREATMENT_ENABLED: 'metWorkReqTreatmentEnabled',
  PERSONAL_INFO_EMAIL_FIRST_ENABLED: 'personalInfoEmailFirstEnabled',
  COMBINED_PROGRAM_CHANGE_PACKET_ENABLED: 'combinedProgramChangePacketEnabled',
  STUDY_COM_ACKNOWLEDGEMENT_ENABLED: 'studyComAcknowledgementEnabled',
};
